module.exports = __webpack_public_path__ + "css/Powercore.909a0e29.css";